// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SliderItem_wrapper__2FhnE","overlay":"SliderItem_overlay__1PvDY","text-opacity":"SliderItem_text-opacity__1dij_"};